import { IdentitySeason, IdentityTeam } from '@reg/shared/model';
import get from 'lodash-es/get';

/**
 * Model to hold seasonGroup resource data from identity
 */
export class IdentitySeasonGroup {
    public id: string = null;
    public name: string = null;
    public season: IdentitySeason = new IdentitySeason();
    public teams: IdentityTeam[] = [];

    constructor(id: string = null, name: string = null) {
        this.id = id;
        this.name = name;
    }

    public clone(): IdentitySeasonGroup {
        const clone: IdentitySeasonGroup = new IdentitySeasonGroup();
        clone.id = this.id;
        clone.name = this.name;
        clone.season = this.season && this.season.clone();
        clone.teams = this.teams && this.teams.map((t: IdentityTeam) => t.clone());

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                type: 'seasonGroup',
                id: this.id,
                attributes: {
                    name: this.name,
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any, included: any[] = null, identitySportName: string = null): IdentitySeasonGroup {
        const data: any = json['data'] || json;
        const attrs: any = data.attributes || {};
        included = included || json.included || [];

        this.id = data.id;
        this.name = attrs.name;

        if (attrs.seasonId) {
            this.season = new IdentitySeason(attrs.seasonId);

            // Fill Season from relationships if it exists
            const season: any = included.filter((i: any) => i.type === 'season' && i.id === attrs.seasonId)[0];

            if (season) {
                this.season = (new IdentitySeason(attrs.seasonId)).deserialize(season, included);
            }
        }

        const teamList: any[] = get(data, 'relationships.teams.data') || [];
        teamList.forEach((x: any) => {
            const item: any = included.filter((i: any) => i.id === x.id)[0];

            if (item) {
                this.teams.push((new IdentityTeam()).deserialize(item, included, identitySportName));
            }
        });

        return this;
    }
}
